/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class TutorialsController {
    public static $inject = [
        'User',
        'Announcement',
        '$uibModal',
        'Uploads',
        'Employee',
        '$scope',
        'Upload',
        'bsLoadingOverlayService',
        'toaster',
    ];

    public user;
    public meetings;
    public announcesCount;
    public birthdays;
    public hasPermission;
    public hasAdminClearance;
    public defaultValue = '';
    public docType: string = '';
    public docLabel: string = '';
    public docObj = {
        name: this.defaultValue,
        reportDate: this.defaultValue,
        file: this.defaultValue,
        action: ''
    };
    public isPassportUpload = false;
    public uploads;
    // object required for upload file directive to upload a file.
    public fileDirModel = {
        fileName: 'Select a file',
        fileLink: undefined
    };
    public employee;
    private empEventName: string;
    private empEventAddData: string;

    constructor(private User: IUserService,
                private Announcement: IAnnouncementService,
                private $uibModal: any,
                private Uploads: any,
                private Employee: IEmpService,
                private $scope: ng.IScope,
                private Upload: any,
                private bsLoadingOverlayService: IBsLoadingService,
                private toaster: toaster.IToasterService) {

        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.user = User.getCurrentUser();
        this.hasPermission = User.hasPermission;
        this.$uibModal = $uibModal;

        this.hasAdminClearance = this.user.userData.user.clearance === 'admin';
        if (!this.user.isSuperUser) {
            this.Announcement.loadAnounces().then((response) => {
                this.announcesCount = response.length;
            });
        }

        // Create empty medical file arrays
        this.Employee.loadEmployee(this.User.getCurrentUser().userData.id).then((response: Restangular.IResponse) => {
            this.employee = response;
            if (!this.employee.extra.employment) {
                this.employee.extra.employment = {}
            }

            if (!this.employee.extra.employment.medical_files) {
                this.employee.extra.employment.medical_files = {}
            }

            if (!this.employee.extra.employment.medical_files.cpr_course) {
                this.employee.extra.employment.medical_files.cpr_course = []
            }

            if (!this.employee.extra.employment.medical_files.fit_for_work) {
                this.employee.extra.employment.medical_files.fit_for_work = []
            }

            if (!this.employee.extra.employment.medical_files.medical_records) {
                this.employee.extra.employment.medical_files.medical_records = []
            }
        });
    }

    // following function is for converting the bootstrap modals into UIB modals.
    public addEditEmploymentDocuments(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/medical_record_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {
        });
    }

    public employmentDocumentEdit(index: any): void {
        if (index === 'new') {
            this.docObj = {
                name: this.defaultValue,
                reportDate: this.defaultValue,
                file: this.defaultValue,
                action: 'add'
            };
            this.fileDirModel = {
                fileName: 'Select a file',
                fileLink: undefined
            }
        }
    }

    public parseFileName(input: any): string {
        if (!_.isEmpty(input)) {
            return decodeURI(input.substring(input.lastIndexOf('/') + 1));
        }
    }

    public uploadDocModalFiles = function (params: any): void {
        const that: any = this;
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let file: any = params.new;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                that.docObj.file = response.data.url;
                that.fileDirModel.fileName = that.parseFileName(that.docObj.file);
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            },
            () => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };

    public documentModalUpload(value: any): void {
        if (value !== true) {
            this.isPassportUpload = false;
        } else {
            this.isPassportUpload = value;
        }
    }

    public deleteUpload = function (params: any): void {

        // this needs to be replaced by the actual
        this.fileDirModel.fileLink = undefined;
        this.fileDirModel.fileName = 'Select a file';
        this.docObj.file = '';
    };

    public youTubeModal(video_id: string): any {
        let that: any = this;
        that.videoUrl = '';
        switch (video_id) {
            case 'safeHands_1':
                that.videoUrl = 'https://www.youtube.com/embed/1FjttF_4jwE';
                break;
            case 'safeHands_2':
                that.videoUrl = 'https://www.youtube.com/embed/nuFLf6Yuc78';
                break;
            case 'safeHands_3':
                that.videoUrl = 'https://www.youtube.com/embed/NCHhkOplip8';
                break;
            case 'safeHands_4':
                that.videoUrl = 'https://www.youtube.com/embed/6165vBQjgpM';
                break;
            case 'safeHands_5':
                that.videoUrl = 'https://www.youtube.com/embed/TgQCa7yaqv8';
                break;
            case 'safeHands_6':
                that.videoUrl = 'https://www.youtube.com/embed/uu2r-Oko_Ck';
                break;
            case 'safeHands_7':
                that.videoUrl = 'https://www.youtube.com/embed/jleDJODIR7I';
                break;
            case 'safeHands_8':
                that.videoUrl = 'https://www.youtube.com/embed/m_G_SJ4Tz7o';
                break;
            case 'safeHands_9':
                that.videoUrl = 'https://www.youtube.com/embed/ZSRhUizVC9o';
                break;
        }

        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/youtube_modal.html',
            controller: ['$scope', '$uibModalInstance', '$sce', function ($scope: any, $uibModalInstance: any, $sce: any): any {
                $scope.trustSrc = function (src: any): void {
                    return $sce.trustAsResourceUrl(src);
                };
                $scope.C = that;
                $scope.modalUrl = that.videoUrl;

                $scope.ok = () => {
                    $uibModalInstance.close();
                };
            }]
        });
        modal_instance.result.then(() => {
        });
    }

    public pdfModal(): any {
        let that: any = this;

        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/pdfview_modal.html',
            windowTopClass: 'fullscreenModal',
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): any {
                $scope.C = that;
                $scope.modalUrl = that.videoUrl;

                $scope.ok = () => {
                    $uibModalInstance.close();
                };
            }]
        });
        modal_instance.result.then(() => {
        });
    }

    public saveEmployeeDocumentEdit(model: any): void {
        let empDocs: any = this.employee.extra.employment.medical_files.medical_records;
        let ldocObj = {
            name: '',
            report_date: '',
            file: '',
        };

        if (model.name !== '') {
            ldocObj.name = model.name;
        }

        if (model.reportDate !== '') {
            ldocObj.report_date = moment(model.reportDate).format('YYYY-MM-DD');
        }

        if (model.file && model.file !== '') {
            ldocObj.file = this.docObj.file;
        }
        empDocs.push(ldocObj);

        this.empEventName = 'safehands.health_files.medical_records.add';

        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let that = this;

        this.employee.put().then((response) => {
                // Check if we need to emit an event log
                if (that.empEventName) {
                    that.emitEvent(that.empEventName, that.empEventAddData);

                    // Reset event data
                    that.empEventName = '';
                    that.empEventAddData = '';
                }
                this.employee = response;
                this.toaster.pop('success', 'Saved');
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            },
            (response: any) => {
                if (response.status === 403) {
                    this.toaster.pop('error', 'Access Denied', response.data.detail);
                } else if (response.status === 400) {
                    this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
                } else {
                    this.toaster.pop('error', 'Server error', 'Please, try again later');
                }
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});

            });
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }

    public delete_doc_modal(doc_index: number): void {
        const empl: any = this.employee;
        const that: this = this;
        const doc: any = empl.extra.employment.medical_files.medical_records[doc_index];
        let doc_title: string = doc.name;

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + doc_title;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                empl.extra.employment.medical_files.medical_records.splice(doc_index, 1);
                this.empEventName = 'safehands.health_files.medical_records.delete';

                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                let that = this;

                this.employee.put().then((response) => {
                        // Check if we need to emit an event log
                        if (that.empEventName) {
                            that.emitEvent(that.empEventName, that.empEventAddData);

                            // Reset event data
                            that.empEventName = '';
                            that.empEventAddData = '';
                        }
                        this.employee = response;
                        this.toaster.pop('success', 'Saved');
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    },
                    (response: any) => {
                        if (response.status === 403) {
                            this.toaster.pop('error', 'Access Denied', response.data.detail);
                        } else if (response.status === 400) {
                            this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
                        } else {
                            this.toaster.pop('error', 'Server error', 'Please, try again later');
                        }
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});

                    });

            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
     }

    public videoSelected(videoSrc: string): void {
        this.$scope.$emit('$EL', 'knowledge_base.view', videoSrc);
    }


}

angular.module('beneple.global')
    .controller('TutorialsController', TutorialsController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/tutorials.controller.ts